let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ePOyH"), load("3XMOA"), load("7Q0UC"), load("c6MKV"), load("aZinD"), load("cyGuT"), load("4R2Ie")]).then(() => parcelRequire('cUMZA'));